import type { GeoJSONSource } from 'maplibre-gl';
import type { ForecastSnapshot } from '../../adapters/forecast-http';
import type { ResearchLayerMap } from './research-layers';
import { gridSelection } from './weather-selection';
export function forecastGrids(data: ForecastSnapshot | null, areaId: string) {
  const seen = new Set<string>();
  return {
    type: 'FeatureCollection' as const,
    features: (data?.forecasts ?? []).flatMap((f) => {
      const key = `${f.region.regionId}:${f.gridIdentity}`;
      if (
        f.sourceMode !== data?.sourceMode ||
        seen.has(key) ||
        (areaId && f.region.regionId !== areaId)
      )
        return [];
      seen.add(key);
      return [
        {
          type: 'Feature' as const,
          geometry: { type: 'Polygon' as const, coordinates: [f.polygon] },
          properties: {
            sourceMode: f.sourceMode,
            selectionId: gridSelection(f),
            label: f.sourceMode === 'DEMO' ? '合成演示网格' : 'NWS 预报网格（非火险区）',
          },
        },
      ];
    }),
  };
}
export function installForecastLayer(
  map: ResearchLayerMap,
  data: ForecastSnapshot | null,
  areaId: string,
) {
  const id = 'vs12-forecast-grid';
  const collection = forecastGrids(data, areaId);
  const source = map.getSource(id) as GeoJSONSource | undefined;
  if (source) source.setData(collection);
  else map.addSource(id, { type: 'geojson', data: collection });
  if (!map.getLayer(id + '-hit'))
    map.addLayer({
      id: id + '-hit',
      source: id,
      type: 'fill',
      paint: { 'fill-opacity': 0 },
    });
  if (!map.getLayer(id))
    map.addLayer({
      id,
      source: id,
      type: 'line',
      paint: {
        'line-color': ['match', ['get', 'sourceMode'], 'DEMO', '#8a50be', '#3876b5'],
        'line-width': 3,
        'line-dasharray': [3, 2],
      },
    });
}
